'use client'

import { useMutation } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { AddFavoriteData, API_Data_Add_Favorite_Response } from "@/interfaces/api/favorites/favorites_types"
import { addFavorite } from "../requests/favorites"

export const useAddFavorite = () => useMutation<API_Data_Add_Favorite_Response, API_Error, { profileId: string, payload: AddFavoriteData }>({
    retry: false,
    mutationFn: addFavorite
})